<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'

    import { authWellyMethods } from "@/state/helpers";
    import { apiCore }  from '../../../constants'
    import axios from 'axios'
    import Swal from "sweetalert2"

    export default {
        components: { Layout, PageHeader },
        props: {},
        data() {
            return {
                config: null,
                statusSend:false,
                statusMsg:""
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            getConfigRiders(){
                let url = `${apiCore}/api/welly/admin/getVarsPay`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    // eslint-disable-next-line
                    //console.log(res)
                    if (res.valid) {
                        // eslint-disable-next-line
                        //console.log(res.varsPay[0])
                        this.config = res.varsPay[0]
                    } 
                })
            }, 
            setConfigRiders(){
                let url = `${apiCore}/api/welly/admin/setVarsPay`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .put(url, this.config, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    // eslint-disable-next-line
                    //console.log(res)
                     if (res.valid){
                        this.statusMsg = ""
                        this.statusSend = false

                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "Configuración almacenada con éxito.",
                            showConfirmButton: false,
                            timer: 4500
                        });

                        this.returnProfile()
                    }
                    else{
                        this.statusMsg = ""
                        this.statusSend = false

                        Swal.fire({
                            position: "top-end",
                            icon: "error",
                            title: "Error al guardar configuración.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                    }
                })
            },
            changeScoreHourByDemand(value){
                this.config.hourByDemandFlag = !value
                
                if(value){
                    this.config.scoreHourByDemand = null
                }
            },
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user
            this.getConfigRiders()
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card-welly">
                    <div class="row">
                        <div class="col-md-12 container-welly">
                            <div class="row scroll1">

                                <div class=" col-sm-12 col-md-12" style="margin: 10px 0 10px 0;">
                                    <h3 class="title-card">
                                        CONFIGURACION DE PUNTOS Y PAGO DE RIDERS
                                    </h3>

                                    <div class="row">

                                        <div class=" col-sm-12 col-md-4" style="margin: 10px 0 10px 0;">

                                            <b>Rate Base</b>
                                            <b-form-input v-model="config.rateBase" type="number" placeholder="Rate Base"></b-form-input>
                                            <br/>

                                            <b>Rate Advertising</b>
                                            <b-form-input v-model="config.rateAdvertising" type="number" placeholder="Rate Advertising"></b-form-input>
                                            <br/>

                                            <b>Rate Night</b>
                                            <b-form-input v-model="config.rateNight" type="number" placeholder="Rate Night"></b-form-input>
                                            <br/>

                                            <b>Rate Night Begin</b>
                                            <b-form-input v-model="config.rateNightBegin" type="number" placeholder="Rate Night Begin"></b-form-input>
                                            <br/>

                                            <b>Rate Night End</b>
                                            <b-form-input v-model="config.rateNightEnd" type="number" placeholder="Rate NightEnd"></b-form-input>
                                            <br/>
                                            
                                        </div>

                                        <div class=" col-sm-12 col-md-4" style="margin: 10px 0 10px 0;">
                                            
                                            <b>Score by Metres</b>
                                            <b-form-input v-model="config.scoreByMetres" type="number" placeholder="Score by Metres"></b-form-input>
                                            <br/>

                                            <b>Metres by Score</b>
                                            <b-form-input v-model="config.metresByScore" type="number" placeholder="Metres by Score"></b-form-input>
                                            <br/>

                                            <b>Score by Currency</b>
                                            <b-form-input v-model="config.scoreByCurrency" type="number" placeholder="Score by Currency"></b-form-input>
                                            <br/>

                                            <b>Currency by Score</b>
                                            <b-form-input v-model="config.currencyByScore" type="number" placeholder="Currency by Score"></b-form-input>
                                            <br/>

                                            <b>Score Hour by Demand</b>
                                            <div class="row">
                                                <div class=" col-sm-12 col-md-4">
                                                    <b-form class="form-check form-switch form-switch-lg" @click="changeScoreHourByDemand(config.hourByDemandFlag)">
                                                        <input
                                                        class="form-check-input"
                                                        id="input-1"
                                                        type="checkbox"
                                                        v-model="config.hourByDemandFlag" :name="config._id"
                                                        /> Aplicar
                                                    </b-form> 
                                                    
                                                </div>
                                                <div class=" col-sm-12 col-md-8">
                                                    <b-form-input v-model="config.scoreHourByDemand" type="number" placeholder="Score Hour by Demand" :disabled="!config.hourByDemandFlag"></b-form-input>
                                                </div>
                                            </div>
                                            <br/>
                                            
                                        </div>

                                        <div class=" col-sm-12 col-md-4" style="margin: 10px 0 10px 0;">

                                            <b>Rate Qualification 1 Star</b>
                                            <b-form-input v-model="config.rateQualification1Star" type="number" placeholder="Rate  Qualification 1 Star"></b-form-input>
                                            <br/>

                                            <b>Rate Qualification 2 Star</b>
                                            <b-form-input v-model="config.rateQualification2Star" type="number" placeholder="Rate  Qualification 2 Star"></b-form-input>
                                            <br/>

                                            <b>Rate Qualification 3 Star</b>
                                            <b-form-input v-model="config.rateQualification3Star" type="number" placeholder="Rate  Qualification 3 Star"></b-form-input>
                                            <br/>

                                            <b>Rate Qualification 4 Star</b>
                                            <b-form-input v-model="config.rateQualification4Star" type="number" placeholder="Rate  Qualification 4 Star"></b-form-input>
                                            <br/>

                                            <b>Rate Qualification 5 Star</b>
                                            <b-form-input v-model="config.rateQualification5Star" type="number" placeholder="Rate  Qualification 5 Star"></b-form-input>
                                            <br/>

                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class=" col-sm-12 col-md-12">
                                            <div style="text-align:right;">
                                                <b-button type="submit" variant="success" v-show="!statusSend" v-on:click="setConfigRiders()">
                                                    Guardar
                                                </b-button> 
                                                <div class="text-card" v-show="statusSend">
                                                    {{statusMsg}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>

        <br/><br/><br/>

    </Layout>
</template>

<style scoped>
</style>